import * as Enumerable from 'linq';

export class ArrayUtility {
    public static replace<T>(items: T[], item: T, index) {
        const newItems = index === -1 ? [...items, item] : [...items.slice(0, index), item, ...items.slice(index + 1)];

        return newItems;
    }

    public static sortByProperty<T>(source: T[], propertyName: string) {
        if (source.length) {
            const type = typeof source[0][propertyName];
            if (type === 'string') return source.sort((a: T, b: T) => (a[propertyName] && b[propertyName] ? a[propertyName].localeCompare(b[propertyName]) : true));
            if (type === 'number') return source.sort((a: T, b: T) => (a[propertyName] && b[propertyName] ? (a[propertyName] < b[propertyName] ? -1 : a[propertyName] > b[propertyName] ? 1 : 0) : 0));
            return source;
        }
        return source;
    }

    public static tryReplace<T>(items: any[], item: T, predicate: (element: T, index: number) => boolean): any[] {
        const index = Enumerable.from(items).indexOf(predicate);
        const newItems = index === -1 ? [...items, item] : [...items.slice(0, index), item, ...items.slice(index + 1)];
        return newItems;
    }

    public static tryPatchReplace<T>(items: any[], item: any, predicate: (element: T, index: number) => boolean): any[] {
        const index = Enumerable.from(items).indexOf(predicate);
        const newItems = index === -1 ? [...items, item] : [...items.slice(0, index), { ...items[index], ...item }, ...items.slice(index + 1)];
        return newItems;
    }

    public static tryRemove<T>(items: any[], predicate: (element: T, index: number) => boolean): any[] {
        const index = Enumerable.from(items).indexOf(predicate);
        const newItems = index === -1 ? [...items] : [...items.slice(0, index), ...items.slice(index + 1)];
        return newItems;
    }

    public static tryPatchValues(desItems: any[], fields: string[], srcItem: any): any[] {
        return desItems.map(w => {
            fields.forEach(key => {
                w[key] = srcItem[key];
            });
            return w;
        });
    }

    public static tryPatchValuesOrAddNew<T>(source: any[], items: any[], predicate: (element1: T, element2: T) => boolean): any[] {
        const newItems = [...source];

        items.forEach(item => {
            const index = Enumerable.from(newItems).indexOf(p => predicate(p, item));

            if (index === -1) {
                newItems.push(item);
                return;
            }

            const sourceItem = newItems[index];
            const keys = Object.keys(item);

            keys.forEach(key => {
                sourceItem[key] = item[key];
            });
        });

        return newItems;
    }
}
